import { Box, GridLayout } from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface ArticleListGridLayoutProps extends PropsWithChildren {
  isNotGridAtMobile?: boolean;
  className?: string;
}

const ArticleListGridLayout = ({
  children,
  isNotGridAtMobile,
  className,
}: ArticleListGridLayoutProps) => {
  return (
    <GridLayout
      gridTemplateAreaClass={twMerge(
        'desktop:grid-areas-article-list-desktop tablet:grid-areas-article-list-tablet grid-areas-article-list-mobile',
        isNotGridAtMobile && 'px-0 flex desktop:grid gap-y-6 tablet:gap-y-10',
        className
      )}
    >
      {isNotGridAtMobile ? (
        <>{children}</>
      ) : (
        <Box className="flex flex-col gap-6 grid-in-content tablet:gap-10">
          {children}
        </Box>
      )}
    </GridLayout>
  );
};

export default ArticleListGridLayout;
